import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  Message as MessageIcon,
  Share as ShareIcon,
  Star as StarIcon,
} from '@mui/icons-material';

interface MetricCardProps {
  title: string;
  value: string;
  trend?: string;
  icon: React.ReactElement;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, trend, icon }) => (
  <Card>
    <CardContent>
      <Box display="flex" alignItems="center" mb={2}>
        <Box mr={1}>{icon}</Box>
        <Typography variant="h6" component="div">
          {title}
        </Typography>
      </Box>
      <Typography variant="h4" component="div" gutterBottom>
        {value}
      </Typography>
      {trend && (
        <Typography variant="body2" color="text.secondary">
          {trend}
        </Typography>
      )}
    </CardContent>
  </Card>
);

const Dashboard: React.FC = () => {
  const metrics = [
    {
      title: 'Total Engagement',
      value: '1,234',
      trend: '+12% from last month',
      icon: <TrendingUpIcon color="primary" />,
    },
    {
      title: 'New Reviews',
      value: '28',
      trend: '4 pending responses',
      icon: <MessageIcon color="primary" />,
    },
    {
      title: 'Social Reach',
      value: '45.2K',
      trend: '+8% this week',
      icon: <ShareIcon color="primary" />,
    },
    {
      title: 'Average Rating',
      value: '4.8',
      trend: 'Across all platforms',
      icon: <StarIcon color="primary" />,
    },
  ];

  const quickActions = [
    'Post Social Update',
    'Respond to Reviews',
    'Update Business Hours',
    'View Analytics Report',
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Welcome back!
      </Typography>
      
      {/* Metrics Grid */}
      <Grid container spacing={3} mb={4}>
        {metrics.map((metric) => (
          <Grid item xs={12} sm={6} md={3} key={metric.title}>
            <MetricCard {...metric} />
          </Grid>
        ))}
      </Grid>

      {/* Quick Actions */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Quick Actions
        </Typography>
        <Grid container spacing={2}>
          {quickActions.map((action) => (
            <Grid item xs={12} sm={6} md={3} key={action}>
              <Button
                variant="outlined"
                fullWidth
                sx={{ height: '100%', textAlign: 'center' }}
              >
                {action}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* Recent Activity */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Recent Activity
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • New 5-star review on Google My Business (2 hours ago)
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Social media post scheduled for tomorrow
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Business hours updated for holiday season
        </Typography>
        <Typography variant="body2" color="text.secondary">
          • Weekly analytics report generated
        </Typography>
      </Paper>
    </Box>
  );
};

export default Dashboard;
